import React, { useEffect } from "react";
import { sendChatMessageToConnect } from "../../../redux/actions/amazonConnectActions";
import { useSelector, useDispatch } from "react-redux";

const Button = ({ click, style, title, id }) => {
  const dispatch = useDispatch();
  const messagePaneReducer = useSelector((state) => state.messagePaneReducer);
  const link = click.actions.find(({ type }) => type === "link");
  const publishText = click.actions.find(({ type }) => type === "publishText");

  useEffect(() => {
    for (
      let index = 0;
      index < messagePaneReducer.messageList.length;
      index++
    ) {
      if (
        Array.isArray(
          messagePaneReducer.messageList[index].messageText.elements
        )
      ) {
        if (
          messagePaneReducer.messageList[index].isTableButtonClicked === true
        ) {
          if (
            document
              .getElementById(`${messagePaneReducer.messageList[index].id}`)
              .querySelectorAll("a").length
          ) {
            let elem = document
              .getElementById(`${messagePaneReducer.messageList[index].id}`)
              .querySelectorAll("a");
            // Disable only buttons that do not have a valid href
            elem.forEach((a) => {
              if (!(a.getAttribute("href") && a.getAttribute("href") !== "#")) {
                a.style.pointerEvents = "none";
                a.style.color = "grey";
              }
            });
          }
        }
      }
    }
  }, []);

  async function handleClick(e) {
    if (Object.values(messagePaneReducer.isChatEnabled).includes(true)) {
      e.preventDefault();
    } else {
      if (publishText) {
        e.preventDefault();
        for (
          let index = 0;
          index < messagePaneReducer.messageList.length;
          index++
        ) {
          if (messagePaneReducer.messageList[index].id === id) {
            messagePaneReducer.messageList[index].isTableButtonClicked = true;
          }
        }
        dispatch(sendChatMessageToConnect(publishText.text, false, id));
      }
    }
  }

  return (
    <div className="button" style={style}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={link?.uri || "#"}
        tabIndex={0}
        className={
          Object.values(messagePaneReducer.isChatEnabled).includes(true)
            ? "-oneX-link--block opacity-lost-conn"
            : "-oneX-link--block"
        }
        onClick={handleClick}
        aria-label={publishText?.text}
      >
        {title}
      </a>
    </div>
  );
  // }
};

export default Button;
